export const enum ViewType {
  LIST_VIEW = 'list',
  CARD_VIEW = 'card',
}
